<template>
  <div >
    <p class="htn">根据信息安全法规，您及客户信息将会得到严格保护！请正确填写您的个人信息。</p>
    <ul class="autonym">
      <li>
        <span>姓名</span>
        <input  class="realName" type="text" placeholder="请输入真实姓名" v-model.trim="realName">
      </li>
      <li>
        <span>证件号码</span>
        <input type="text" placeholder="请输入您的身份证号码" v-model.trim="identityCode" oninput="if(value.length>18)value=value.slice(0,18)">
      </li>
    </ul>
    <div class="btn" @click="autonymYeal">注册</div>

    <!-- 提示框-->
    <prompt ref="errBox" :infor1="infor1"></prompt>
  </div>
</template>

<script>
  import prompt from '@/components/prompt'
  export default {
    data(){
      return{
        realName:"",
        identityCode:"",
        telephone:"",
        code:"",
        password:"",
        email:"",
        invitedCode:"",
        infor1:"",
      }
    },
    components: {
      prompt,
    },
    mounted () {
      this.receive()
    },
    methods: {
      //接受参数
      receive(){
        this.telephone = this.$route.query.telephone
        this.code = this.$route.query.code,
          this.password = this.$route.query.password,
          this.email = this.$route.query.email,
          this.invitedCode = this.$route.query.invitedCode,
          this.sourceCode =  this.$route.query.sourceCode
      },
      //注册接口
      autonymYeal: function () {
        let registerAutonym = {
          realName: this.realName,
          identityCode: this.identityCode
        }
        const em = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/;
        if (registerAutonym.realName == "") {
          this.$refs.errBox.errorShow();
          this.infor1 = '请输真实姓名！'
          return false;
        } else if (registerAutonym.identityCode == "" || !em.test(registerAutonym.identityCode)) {
          this.$refs.errBox.errorShow();
          this.infor1 = '请输正确的身份证号！'
          return false;
        }
        //注册接口
        this.$http({
          method:"post",
          url:'/userInfo/register',
          headers:{'Content-Type':'application/x-www-form-urlencoded;charset=utf-8'},
          dataType: 'JSONP',

          params:{
            telephone: this.telephone,
            code: this.code,
            password: this.password,
            email: this.email,
            realName: this.realName,
            identityCode: this.identityCode,
            invitedCode: this.invitedCode,
            sourceCode:this.sourceCode,

          }
        }).then(res => {
          var message = res.data.message;
        if(res.data.code == "200"){
          window.location.href = "http://sj.qq.com/myapp/detail.htm?apkName=com.txkj.htbpro";
        }
        if(res.data.code == "500"){
          this.$refs.errBox.errorShow();
          this.infor1 = message;
          return false;
        }
      })

      }
    }

  }
</script>

<style scoped lang="less">
  .htn{
    padding:16/75rem 30/75rem;
    font-size:24/75rem;
    color:#E6464A;
    line-height:45/75rem;
    background:rgba(255,238,233,1);
  }
  .autonym{
    background:#fff;
  li{
    font-size:30/75rem;
    height:100/75rem;
    line-height:100/75rem;
    padding:0 30/75rem;
    border-bottom:1/75rem solid #E2E5E7;
  &:last-child{
     border-bottom:none;
   }
  .realName{
    margin-left:105/75rem;
  }
  input{
    margin-left:50/75rem;
    height:70/75rem;
    border:none;
    font-size:28/75rem;
    -webkit-tap-highlight-color: rgba(0,0,0,0);
    -webkit-appearance: none;
  }
  }
  }
  .btn{
    width:629/75rem;
    height:100/75rem;
    line-height:100/75rem;
    margin:auto;
    background:#E6464A;
    color:#fff;
    font-size:32/75rem;
    border-radius: 6px;
    text-align:center;
    box-shadow:4px 0px 16px rgba(153,153,153,0.63);
    margin-top:60/75rem;
  }

</style>



// WEBPACK FOOTER //
// src/pages/autonymShqd1.vue